import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { environment } from '@environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

interface Payload {
  token: string;
}
@Injectable({ providedIn: 'root' })
export class Job1j1sWebservice {
  private readonly baseUrl: string;

  constructor(private readonly http: HttpClient, @Inject(DOCUMENT) private readonly document: any) {
    this.baseUrl = environment.api.job_api_v2.replace('%host%', this.getDomain());
  }

  getPublicAccessToken(): Observable<string> {
    return this.http.get<Payload>(`${this.baseUrl}/v1/pe/auth/public`).pipe(map((payload: Payload) => payload.token));
  }

  getPrivateAccessToken(): Observable<string> {
    return this.http.get<Payload>(`${this.baseUrl}/v1/pe/auth/private`).pipe(map((payload: Payload) => payload.token));
  }

  getRomeAccessToken(): Observable<string> {
    return this.http.get<Payload>(`${this.baseUrl}/v1/pe/auth/rome`).pipe(map((payload: Payload) => payload.token));
  }

  private getDomain(): string {
    const hostnameArray = this.document.location.hostname.split('.');
    return hostnameArray.splice(-hostnameArray.length + 1).join('.');
  }
}
